const EmployeesScreen = () => {
  
    return (
       <p>Employees Screen here</p>
    )
}

export default EmployeesScreen